import AddNew from "./AddNew";
import Users from "./Users";

export default { AddNew, Users };
